import { useState, useCallback, useEffect } from 'react';
import useAxios from '@/hooks/use-axios';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';
import { formatPrice } from '@/lib/numbers';

import { Image as ImageIcon, Check } from 'lucide-react';

const UpgradePackage = ({
  OnPurchase,
  packages,
  currency,
  ...props
}) => {
  // const [packages, setPackages] = useState([]);
  const [subscriptionType, setSubscriptionType] = useState('monthly');
  // const [currency, setCurrency] = useState('USD');

  const safeEmit = (callback, payload) => {
    if (typeof callback === 'function') {
      callback(payload);
    } else {
      console.warn('Parent callback tidak tersedia');
    }
  };

  const showingPackages = () => {
    return packages.filter((p) => p.duration_months === (subscriptionType === 'monthly' ? 1 : 12));
  };

  const isRecommended = (data) => {
    return data.is_recommended === true;
  };

  return (
    <section className="">
      <div className="container mx-auto px-4 max-w-screen-xl">
        {/* Package Cards */}
        {packages.length > 0 && (
          <>
            <div className="flex gap-2 mx-auto mt-[1.5rem] mb-[2.25rem] items-center justify-start">
              <Button
                variant={subscriptionType === 'monthly' ? 'default' : 'ghost'}
                onClick={() => setSubscriptionType('monthly')}
              >
                Tagihan Bulanan
              </Button>
              <Button
                variant={subscriptionType === 'yearly' ? 'default' : 'ghost'}
                onClick={() => setSubscriptionType('yearly')}
              >
                Tagihan Tahunan
                <Badge> 14% Off</Badge>
              </Button>
            </div>
            <div className="grid md:grid-cols-3 gap-6 mx-auto">
              {showingPackages().map((pkg) => (
                <div
                  key={pkg.id}
                  className={
                    'card-packages transition-all cursor-pointer group' +
                    (isRecommended(pkg) ? ' active' : '')
                  }
                  data-testid={`package-card-${pkg.id}`}
                >
                  <h4 className="text-[1.375rem] leading-[1.75rem] font-bold mb-[1.125rem] text-primary-500 transition-colors flex items-center justify-center gap-2">
                    {pkg.name} {isRecommended(pkg) && <Badge> Recommended </Badge>}
                  </h4>
                  <h3 className="text-[1.375rem] leading-[1.75rem] font-bold mb-8 text-center text-white">
                    {formatPrice(pkg.price, pkg.currency || currency)}/bulan
                  </h3>
                  <ul className="space-y-4 mb-6">
                    {pkg.features?.slice(0, 10).map((feature, i) => (
                      <li key={i} className="text-base font-normal flex items-center gap-2">
                        <span className="w-6 h-6 rounded-full bg-primary-500 grid place-content-center">
                          <Check className="w-4 h-4 text-white " />
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Button
                    variant={isRecommended(pkg) ? 'default' : 'dark'}
                    className="w-full"
                    size="xl"
                    onClick={() => safeEmit(OnPurchase, pkg)}
                  >
                    Pilih Paket
                  </Button>
                </div>
              ))}
            </div>
            <div className="text-center mt-6 card-packages justify-between flex flex-col md:flex-row gap-4">
              <div className="flex items-center">
                <h3 className="text-[1.375rem] text-primary-400 font-bold mr-4">
                  ENTERPRISE plan&nbsp;
                  <span className="text-base text-white font-inter font-normal">
                    Untuk tim yang butuh custom limits, enterprise security, dan dedicated support.
                  </span>
                </h3>
              </div>
              <a href="https://wa.me/6285760070056?text=Halo,%20saya%20ingin%20menggunakan%20paket%20enterprise%20plan%20GarudaQR" target="_blank" data-testid="view-all-packages">
                <Button variant="dark" className="w-full" size="xl">
                  Hubungi Kami
                </Button>
              </a>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default UpgradePackage;
